import { render, staticRenderFns } from "./DonutChart04.vue?vue&type=template&id=045c9b83&scoped=true"
import script from "./DonutChart04.vue?vue&type=script&lang=js"
export * from "./DonutChart04.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045c9b83",
  null
  
)

export default component.exports